import { makeAutoObservable } from "mobx";
import { toPairs } from "../../collections";
import { CheckboxFieldController } from "../../form";
export class ConsentsFormController {
    constructor(params) {
        this.consents = params.consents;
        this.subscribeEmail = new CheckboxFieldController({
            initialValue: this.consents.subscribeEmail,
            onUpdate: (value) => {
                this.consents.subscribeEmail = value;
                this.updateMarketingValue();
            },
        });
        this.subscribePhone = new CheckboxFieldController({
            initialValue: this.consents.subscribePhone,
            onUpdate: (value) => {
                this.consents.subscribePhone = value;
                this.updateMarketingValue();
            },
        });
        this.marketingConsent = new CheckboxFieldController({
            initialValue: this.consents.subscribeEmail || this.consents.subscribePhone,
            onUpdate: (value) => {
                this.subscribeEmail.change(value);
                this.subscribePhone.change(value);
            },
        });
        this.subscribeRestaumaticEmail = new CheckboxFieldController({
            initialValue: this.consents.subscribeRestaumaticEmail,
            onUpdate: (value) => {
                this.consents.subscribeRestaumaticEmail = value;
                this.updateMarketingRestaumaticValue();
            },
        });
        this.subscribeRestaumaticPhone = new CheckboxFieldController({
            initialValue: this.consents.subscribeRestaumaticPhone,
            onUpdate: (value) => {
                this.consents.subscribeRestaumaticPhone = value;
                this.updateMarketingRestaumaticValue();
            },
        });
        this.marketingRestaumaticConsent = new CheckboxFieldController({
            initialValue: this.consents.subscribeRestaumaticEmail ||
                this.consents.subscribeRestaumaticPhone,
            onUpdate: (value) => {
                this.subscribeRestaumaticEmail.change(value);
                this.subscribeRestaumaticPhone.change(value);
            },
        });
        this.allMarketingConsent = new CheckboxFieldController({
            initialValue: this.consents.subscribeEmail ||
                this.consents.subscribePhone ||
                this.consents.subscribeRestaumaticEmail ||
                this.consents.subscribeRestaumaticPhone,
            onUpdate: (value) => {
                this.marketingConsent.change(value);
                this.marketingRestaumaticConsent.change(value);
            },
        });
        makeAutoObservable(this);
    }
    updateMarketingValue() {
        this.marketingConsent.changeWithoutUpdate(this.consents.subscribeEmail || this.consents.subscribePhone);
        this.updateAllMarketingValue();
    }
    updateMarketingRestaumaticValue() {
        this.marketingRestaumaticConsent.changeWithoutUpdate(this.consents.subscribeRestaumaticEmail ||
            this.consents.subscribeRestaumaticPhone);
        this.updateAllMarketingValue();
    }
    updateAllMarketingValue() {
        this.allMarketingConsent.changeWithoutUpdate(this.consents.subscribeEmail ||
            this.consents.subscribePhone ||
            this.consents.subscribeRestaumaticEmail ||
            this.consents.subscribeRestaumaticPhone);
    }
    get isAllMarketingConsentIndeterminate() {
        const { subscribeEmail, subscribePhone, subscribeRestaumaticEmail, subscribeRestaumaticPhone, } = this.consents;
        const someChecked = subscribeEmail ||
            subscribePhone ||
            subscribeRestaumaticEmail ||
            subscribeRestaumaticPhone;
        const allChecked = subscribeEmail &&
            subscribePhone &&
            subscribeRestaumaticEmail &&
            subscribeRestaumaticPhone;
        return someChecked && !allChecked;
    }
    get isMarketingConsentIndeterminate() {
        const { subscribeEmail, subscribePhone } = this.consents;
        return ((subscribeEmail || subscribePhone) && !(subscribeEmail && subscribePhone));
    }
    get isMarketingRestaumaticConsentIndeterminate() {
        const { subscribeRestaumaticEmail, subscribeRestaumaticPhone } = this.consents;
        return ((subscribeRestaumaticEmail || subscribeRestaumaticPhone) &&
            !(subscribeRestaumaticEmail && subscribeRestaumaticPhone));
    }
    get fields() {
        return {
            allMarketingConsent: this.allMarketingConsent,
            marketingConsent: this.marketingConsent,
            subscribeEmail: this.subscribeEmail,
            subscribePhone: this.subscribePhone,
            marketingRestaumaticConsent: this.marketingRestaumaticConsent,
            subscribeRestaumaticEmail: this.subscribeRestaumaticEmail,
            subscribeRestaumaticPhone: this.subscribeRestaumaticPhone,
        };
    }
    get fieldsArray() {
        return toPairs(this.fields).map(([_, field]) => field);
    }
    get isDirty() {
        return this.fieldsArray.some((field) => field.isDirty);
    }
    get isTouched() {
        return this.fieldsArray.some((field) => field.isTouched);
    }
    get isInvalid() {
        const fieldsInvalid = this.fieldsArray.some((field) => field.isInvalid);
        return fieldsInvalid;
    }
    get isValid() {
        return !this.isInvalid;
    }
    get domain() {
        return this.consents;
    }
    submit() {
        this.fieldsArray.forEach((field) => field.blur());
    }
}
